import { BioSampleSiteQueryService } from '@csp/csp-common-hbs';
import { SiteNumberAndName } from '@csp/csp-common-hbs-model';
import { AlertError, Box, EmptyCard, TemporaryDrawerWide } from '@csp/csp-web-ui';
import { ErrorService } from '@csp/web-common';
import { FC, useEffect, useState } from 'react';
import { useStudyContext } from '../../../../common/context/study/useStudyContext';
import { DividerCol } from '../../hbs-details/component/DividerCol';
import { useHbsSearchParams } from '../../hook/useHbsSearchParams';
import { BioSampleContentService } from '../../service/BioSampleContentService';
import { KitContainers } from '../component/KitContainers';
import { KitInformation } from '../component/KitInformation';
import { useKit } from '../hook/useKit';

const DRAWER_ID = 'bio-sample-kit-details-drawer';

export const KitDetailsDrawer: FC = () => {
  const { kitCode } = useHbsSearchParams();
  const { isOpen, onClose, isLoading, kitItem, error, notFoundMessage } = useKit({ kitCode });
  const { study } = useStudyContext();
  const texts = BioSampleContentService.getKitDetailsTexts();
  const [mismatchingSites, setMismatchingSites] = useState<SiteNumberAndName[]>([]);

  useEffect(() => {
    if (kitItem) {
      BioSampleSiteQueryService.findMismatchingSites({ sites: study.sites, containers: kitItem.kitContainers })
        .then(setMismatchingSites)
        .catch(error =>
          ErrorService.handleError({ error, context: { message: 'Failed to match kit containers with user sites' } }),
        );
    }
  }, [kitItem, study]);

  return (
    <TemporaryDrawerWide
      onClose={onClose}
      open={isOpen}
      header={texts.drawer.header.drawer.text}
      isLoading={isLoading}
      id={DRAWER_ID}
      error={error?.message}
    >
      <Box mx={4} py={3} width={'100%'}>
        <AlertError message={error?.message} />
        {notFoundMessage && <EmptyCard title={notFoundMessage} />}

        {kitItem?.kitDetails && (
          <>
            <KitInformation
              mismatchingSites={mismatchingSites}
              kitDetails={kitItem.kitDetails}
              supportedVisits={kitItem.supportedVisits}
            />
            <DividerCol py={2} />
            <KitContainers containers={kitItem.kitContainers} />
          </>
        )}
      </Box>
    </TemporaryDrawerWide>
  );
};
